import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Mail } from "lucide-react";
import { api } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await api.post("/auth/forgot-password", { email, origin_url: window.location.origin }); } catch {}
    finally { setBusy(false); setSent(true); }
  };
  return (
    <div className="payment-result" data-testid="forgot-password-page">
      <div className="pay-card">
        {sent ? (
          <>
            <span className="pay-ic ok"><Mail size={34} /></span>
            <h1>Check your email</h1>
            <p>If an account exists for <b>{email}</b>, we've sent a link to reset your password. It expires in 30 minutes.</p>
            <Link to="/login" className="primary-btn" data-testid="forgot-back-signin">Back to sign in</Link>
          </>
        ) : (
          <form onSubmit={submit} data-testid="forgot-form">
            <h1>Reset your password</h1>
            <p>Enter your email and we'll send you a secure reset link.</p>
            <input className="auth-input" type="email" required placeholder="you@company.com" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input" />
            <button className="primary-btn full" disabled={busy} data-testid="forgot-submit">{busy ? "Sending…" : "Send reset link"}</button>
            <Link to="/login" className="pay-back" data-testid="forgot-back"><ArrowLeft size={14} /> Back to sign in</Link>
          </form>
        )}
      </div>
    </div>
  );
}
